import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import Img from 'gatsby-image';
import Steps from '../Steps/Steps';
import './Hero.less';

const Hero = ({hero, ...rest}) => {
    const {heroImg} = useStaticQuery(graphql`
        query {
            heroImg: file(name: {eq: "hero"}) {
                childImageSharp {
                    fluid(maxWidth: 2000) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <div className="Hero">
            <Img
                className="Hero__image"
                fluid={heroImg.childImageSharp.fluid}
                style={{position: 'absolute'}}
            />
            <div className="Hero__content text-center">
                <h1 className="Hero__title text-white h1--colossal">
                    {hero.title}
                </h1>
                <p
                    className="text-white Hero__body"
                    dangerouslySetInnerHTML={{__html: hero.body}}
                />
                <div className="contact">
                    <Steps {...rest} />
                </div>
            </div>
        </div>
    );
};

export default Hero;
